import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Label, TextInput, Button } from "flowbite-react";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import * as func from "../../api/apiHelper.js"; 
import * as urls from "../../api/urlHelper.js"; 
import { useNavigate } from "react-router-dom";
import traditionalFlower from "../../assets/traditionalPatternleft.png";
import logo from "../../assets/Mobile logo 1 - XL (1).png";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [hashedOtp,setHashedOtp]= useState(null)
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };



  const emailFormik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      const response = await func.post(urls.FORGOT_PWD_SEND_OTP_URL, {email:values.email.toLowerCase()});
      if (response.status === 200) {
        setHashedOtp(response.data.token)
        toast.info(response.data.otp)
        toast.success("OTP sent to your email!");
        setStep(2); 
      } else {
        toast.error(response);
      }
    },
  });

  const [isResetPasswordEnable,setIsResetPasswordEnable]= useState(true)

  const otpFormik = useFormik({
    initialValues: { otp: "", password: "" ,confirmPassword:""},
  


    validationSchema: Yup.object({
      otp: Yup.string().required("OTP is required"),
      password: Yup.string().when([], {
        is: () => step === 2,
        then: (schema) =>
          schema
            .min(8, "Min 8 chars")
            .matches(/[A-Z]/, "Must have 1 uppercase")
            .matches(/[a-z]/, "Must have 1 lowercase")
            .matches(/\d/, "Must have 1 digit")
            .matches(/[,]/, "Must have 1 comma")
            .matches(/[\W_]/, "Must have 1 special char")
            .test(
              "no-sequential-characters",
              "No more than 5 same chars",
              (value) => {
                const sequences = /([a-zA-Z0-9])\1{5}/;
                return !sequences.test(value);
              }
            )
            .test(
              "no-ascending-or-descending-sequences",
              "No sequences like abcdef or 123456",
              (value) => {
                const hasSequentialChars = (str) => {
                  for (let i = 0; i < str?.length - 1; i++) {
                    if (str.charCodeAt(i) + 1 !== str.charCodeAt(i + 1))
                      return false;
                  }
                  return true;
                };
                const hasDescendingChars = (str) => {
                  for (let i = 0; i < str?.length - 1; i++) {
                    if (str.charCodeAt(i) - 1 !== str.charCodeAt(i + 1))
                      return false;
                  }
                  return true;
                };
                for (let i = 0; i <= value?.length - 6; i++) {
                  const substring = value.slice(i, i + 6);
                  if (
                    hasSequentialChars(substring) ||
                    hasDescendingChars(substring)
                  ) {
                    return false;
                  }
                }
                return true;
              }
            )
            .test(
              "comma-not-at-start-or-end",
              "Comma must not be at the start or end",
              (value) => {
                const length = value.length;
                const commaIndex = value.indexOf(",");
                return commaIndex > 0 && commaIndex < length - 1;
              }
            )
            .required("Password is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      confirmPassword: Yup.string().when([], {
        is: () => step === 2,
        then: (schema) =>
          schema
            .min(8, "Min 8 chars")
            .matches(/[A-Z]/, "Must have 1 uppercase")
            .matches(/[a-z]/, "Must have 1 lowercase")
            .matches(/\d/, "Must have 1 digit")
            .matches(/[,]/, "Must have 1 comma")
            .matches(/[\W_]/, "Must have 1 special char")
            .test(
              "no-sequential-characters",
              "No more than 5 same chars",
              (value) => {
                const sequences = /([a-zA-Z0-9])\1{5}/;
                return !sequences.test(value);
              }
            )
            .test(
              "no-ascending-or-descending-sequences",
              "No sequences like abcdef or 123456",
              (value) => {
                const hasSequentialChars = (str) => {
                  for (let i = 0; i < str?.length - 1; i++) {
                    if (str.charCodeAt(i) + 1 !== str.charCodeAt(i + 1))
                      return false;
                  }
                  return true;
                };
                const hasDescendingChars = (str) => {
                  for (let i = 0; i < str?.length - 1; i++) {
                    if (str.charCodeAt(i) - 1 !== str.charCodeAt(i + 1))
                      return false;
                  }
                  return true;
                };
                for (let i = 0; i <= value?.length - 6; i++) {
                  const substring = value.slice(i, i + 6);
                  if (
                    hasSequentialChars(substring) ||
                    hasDescendingChars(substring)
                  ) {
                    return false;
                  }
                }
                return true;
              }
            )
            .test(
              "comma-not-at-start-or-end",
              "Comma must not be at the start or end",
              (value) => {
                const length = value.length;
                const commaIndex = value.indexOf(",");
                return commaIndex > 0 && commaIndex < length - 1;
              }
            )
            .oneOf([Yup.ref('password')], "Passwords must match") 
            .required("Confirm Password is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    

    onSubmit: async (values) => {
      setIsResetPasswordEnable(false)

      if(hashedOtp===null){
        toast.warn("Error Try Again !")
      }
      const apiBody =  { otp: values.otp, newPassword: values.password,hashedOtpToken:hashedOtp }

        const response = await func.post(urls.VERIFY_RESET_PWD_OTP, apiBody);
        if (response.status === 200) {
          toast.success("Password reset successful!");
          navigate("/login"); 
        } else {
          toast.error(response);
        }
        setIsResetPasswordEnable(true)
    },
  });

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#19224B]">
      <img
        src={traditionalFlower}
        alt="Traditional Flower Top Right"
        className="absolute top-0 right-0 w-1/4"
        style={{ transform: "rotate(180deg)" }}
      />
      <div
        className="w-full max-w-md p-8 rounded-lg shadow-lg"
        style={{ backgroundColor: "#E5E9F2" }}
      >
        <div className="flex justify-center mb-1 ">
          <img
            src={logo}
            alt="Brand Logo"
            className="h-14"
            style={{ height: "50px" }}
          />
        </div>

        <h6 className="font-bold text-center text-[#19224B] m-0">
          {step === 1 ? "Forgot Password" : "Reset Password"}
        </h6>
        <form
          onSubmit={
            step === 1 ? emailFormik.handleSubmit : otpFormik.handleSubmit
          }
          className="mt-6"
        >
          {step === 1 ? (
            <>
              <Label htmlFor="email" className="mb-2 block text-start">
                Email
              </Label>
              <TextInput
                id="email"
                name="email"
                type="email"
                placeholder="admin@matchmatrix.com"
                value={emailFormik.values.email}
                onChange={emailFormik.handleChange}
                required
                style={{ borderColor: "#D4A84D", boxShadow: "none" }}
              />
              {emailFormik.touched.email && emailFormik.errors.email && (
                <div className="text-red-600">{emailFormik.errors.email}</div>
              )}
              <Button
                type="submit"
                className="w-full mt-6 text-white"
                style={{ backgroundColor: "#D4A84D" }}
              >
                Send OTP
              </Button>
            </>
          ) : (
            <>
              <Label htmlFor="otp" className="mb-2 block text-start">
                OTP
              </Label>
              <TextInput
                id="otp"
                name="otp"
                type="text"
                placeholder="Enter OTP"
                value={otpFormik.values.otp}
                onChange={otpFormik.handleChange}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 4))}
                required
                style={{ borderColor: "#D4A84D", boxShadow: "none" }}
              />
              {otpFormik.touched.otp && otpFormik.errors.otp && (
                <div className="text-red-600">{otpFormik.errors.otp}</div>
              )}

              <Label htmlFor="password" className="mb-2 block text-start mt-4">
                New Password
              </Label>

              <div className="relative">
                <TextInput
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={otpFormik.values.password}
                  onChange={otpFormik.handleChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 40))
                  }
                  required
                  style={{
                    borderColor: "#D4A84D", // Border color
                    boxShadow: "none", // Remove default shadow
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#FCE29B")}
                  onBlur={(e) => (e.target.style.borderColor = "#D4A84D")}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? (
                    <FaEyeSlash color="#D4A84D" />
                  ) : (
                    <FaEye color="#D4A84D" />
                  )}{" "}
                  {/* Eye icon toggle */}
                </button>
              </div>

              {otpFormik.touched.password && otpFormik.errors.password && (
                <div className="text-red-600 text-sm">{otpFormik.errors.password}</div>
              )}

              <Label
                htmlFor="confirmPassword"
                className="mb-2 block text-start mt-4"
              >
                Confirm Password
              </Label>

              <div className="relative">
                <TextInput
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={otpFormik.values.confirmPassword}
                  onChange={otpFormik.handleChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 40))
                  }
                  required
                  style={{
                    borderColor: "#D4A84D",
                    boxShadow: "none",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#FCE29B")}
                  onBlur={(e) => (e.target.style.borderColor = "#D4A84D")}
                />
                <button
                  type="button"
                  onClick={toggleConfirmPasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash color="#D4A84D" />
                  ) : (
                    <FaEye color="#D4A84D" />
                  )}{" "}
                </button>
              </div>

              {otpFormik.touched.confirmPassword &&
                otpFormik.errors.confirmPassword && (
                  <div className="text-red-600 text-sm">
                    {otpFormik.errors.confirmPassword}
                  </div>
                )}

              <Button
                type="submit"
                disabled={!isResetPasswordEnable}
                className="w-full mt-6 text-white"
                style={{ backgroundColor: "#D4A84D" }}
              >
                Reset Password
              </Button>
            </>
          )}
        </form>
      </div>

      {/* Bottom left image */}
      <img
        src={traditionalFlower}
        alt="Traditional Flower Bottom Left"
        className="absolute bottom-0 left-0 w-1/4"
      />
    </div>
  );
};

export default ForgotPassword;
